import React, { Component } from 'react';
import TimeAgo from 'react-timeago'
import {
    Link,
  } from 'react-router-dom'
  
// import "./home.css"
class PublieData extends Component {
    constructor(props){
        super(props)
        this.state={
            isShow:false,
             showList: false,
            // value: []
        }
        
    }
    componentDidMount() {
      
  
        // this.setState({showList: false})
      }

        renderValue() {
                let {value} = this.state;
                if(!value.length) return "Select..."
                else return value.join(', ')
        }

      handleItemClick=(active, val)=> {
        // let {value} = this.state;
        
        // if(active) value = [...value, val]
        // else value = value.filter(e => e != val);
        
        // this.setState({value})
        console.log("state", this.state.value)
        this.props.clickpick(active , val)
      }
      
    showedit=()=>{

      this.setState({
          isShow:true
      })
      console.log("------", this.state.isShow)
    }
    closeshow = ( )=>{
        this.setState({
            isShow:false
        }) 
    }

  render() {
      
    // var divStyle = {
    //     color: 'white',
    //     background: "red",
    //     height:"auto",
    //     WebkitTransition: 'all', // note the capital 'W' here
    //     "margin-top":"110px"
        
    //   };
    return (
        <div className="table-cos-public">
          {
              this.state.isShow ? 
              <div className="row-public">
                 <div className="cell-show-tuition">
                   <p className="lable-tuition">   <i className="fas fa-file-signature"></i></p> {this.props.name}
                </div>
                <div className="cell-show-tuition">
                <p className="lable-tuition">  <i className="fas fa-money-bill-alt"></i></p> N{this.props.amount}
                </div>
                <div className="cell-show-tuition">
                 <p className="lable-tuition"> <i className="fas fa-question"></i></p> {this.props.description}
               
                </div>
                <div className="cell">   

                <Link className="button is-small is-success "  to={`/payment/${this.props.id}`} params={{ name: this.props.name }}>Make Payment</Link>
               
                      
                    <button className="button is-small is-link " onClick={this.closeshow}><i className="far fa-times-circle"></i></button>   
                </div>
                <div className="cell-public-date">
                    <TimeAgo date={this.props.date} />
                </div>
               </div>
               
         :
         <div className="row-public" key={this.props.id}>
           {/* {this.renderValue()} */}
                 {/* <div className="public-cell-select-body">
                 <ListItem handleClick={this.handleItemClick} value={this.props.id}/>
                </div>     */}
                <div className="cell">
                    {this.props.name}
                </div>
                <div className="cell">
                    {this.props.amount} 
                    
                </div>
                
                <div className="cell">   
                    <a className="button is-small is-success " target="_blank"  href="http://uvune.com/" params={{ name: this.props.name }}>Make Payment</a>
                    <button className="button is-small is-link " onClick={this.showedit}><i className="far fa-eye"></i></button>   
                </div>
            
                <div className="cell-public-date">
                    <TimeAgo date={this.props.date} />
                </div>
                
                
                <div className="cell-button">
                
                </div>    
        </div>   
          }
         <div className="hr-cos">
      
         </div>
       </div>


    )

}





}

export default PublieData;


class ListItem extends React.Component {
    constructor(props) {
      super(props);
      this.state = {active: true}
    }
    
    render() {
      return (
        <a
        onClick={() => {
          this.setState(prevState => {
            let newState = !prevState.active;
            this.props.handleClick(newState, this.props.value);
            return {active: newState}
          })
        }}
        className={
          !this.state.active ? 'far fa-circle' : 'far fa-check-circle'
      
      }
        href="#">
        {/* {this.props.value} */}
        </a>
      )
    }
  }
  


// WEBPACK FOOTER //
// ./src/component/public/publicData.js